var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "#f3f4f6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 560,
    height: 400,
    rx: 20,
    fill: "#fff",
    stroke: "#e5e7eb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 140,
    width: 500,
    height: 40,
    rx: 8,
    fill: "#e0e7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 200,
    width: 360,
    height: 20,
    rx: 4,
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 240,
    width: 320,
    height: 20,
    rx: 4,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 280,
    width: 420,
    height: 20,
    rx: 4,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 340,
    width: 220,
    height: 40,
    rx: 8,
    fill: "#4f46e5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 368,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#ffffff"
  }, "Start Writing"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "decor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 30,
    fill: "#6366f1",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 540,
    r: 50,
    fill: "#ec4899",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 80,
    r: 20,
    fill: "#f59e0b",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.dea4289ea20a7d6ec692e611813cdbff.svg";
export { ForwardRef as ReactComponent };